import React, {useEffect} from "react";
import {authRoutes, preKs, routes as rs} from './routes';
import {history} from '../history'
import {autoApi, encrypt, getData, getInit, useQuery, widthStore, WS} from '../stores/util'
import Window from "../Components/common/window";
import {gamesStore} from "../stores/games";
import {PopAva} from "../Components/common/av/ava";
import {Navigate, Route, Router, Routes, useMatch} from "react-router-dom";
import {walletStore} from "../stores/third";
import {ServiceWin} from "../Components/common/co";
import {userStore} from "../stores/userStore";
import {alert} from "../stores/global";
import {Loading} from "../Components/loading";
import "../Components/sheet/s.scss"
import {SrvPop} from "../Components/popSrv";

const lzC = {}
const lzP = {}
const t = setInterval(() => {
    let n = 3;
    for (let i = 0, l = preKs.length; i < l && n > 0; i++) {
        const kk = preKs[i];
        if (!lzC[kk]) {
            preLoad(kk)
            n--
        }
    }
    if (n) clearInterval(t);
}, 1e3)


function preLoad(key) {
    const nx = lzP[key];
    if (nx) {
        return new Promise((r) => nx.then(a => {
            delete lzP[key];
            r(a);
        }))
    } else return lzP[key] = new Promise((resolve) => {
        const cp = rs[key];
        const [p, k] = cp.component || cp;
        p().then(a => {
            if (k) {
                a = a[k]
            }
            const C = a && a.default || a
            lzC[key] = props => <C {...props}/>;
            resolve({default: lzC[key]});
        })
    })
}

function lzK(key) {
    const c = lzC[key];
    if (c) return c;
    else return React.lazy(() => preLoad(key))
}


function auth(p) {
    const {token, user_level, is_agent} = userStore;
    for (let i = 0, l = authRoutes.length; i < l; i++) {
        const [c, lv] = authRoutes[i];
        const tp = typeof c;
        let v = 0;
        if (tp === 'string') v = c === p;
        else if (c instanceof RegExp) v = c.test(p);
        else if (tp === 'function') v = c(p);
        if (v) {
            if (lv === user_level || (/agent/.test(p) && !is_agent)) return 2
            if (token) return 1
            return 0
        }
    }
    return 1
}

const Cpm = (p) => {
    const {cpm, match, c} = p;
    const props = {...p, history, getData, encrypt, alert};
    delete props.c;
    delete props.cpm;
    if (match) {
        props.params = match.params
    }
    const Rt = cpm.component || cpm;
    delete props.class;
    const r = auth(c);
    return r === 2 ? <Navigate to={'/'}/> : r ?
        <Rt {...{...props}}/> :
        <Navigate
            to={{
                pathname: "/login",
                state: {from: props.location}
            }}
        />;
}

const Init = widthStore(({userStore, alert}) => {
    const {token} = userStore;
    const [thirdProduct] = useQuery('thirdProduct');
    const [queryUS] = useQuery('userSetting');
    const [qW] = useQuery('getWays');
    const [tps] = useQuery('aType');
    const [qB] = useQuery('myBankCard');
    const [rec] = useQuery('getRecentGame');
    useEffect(() => {
        alert.hide();
        gamesStore.loading = false;
        thirdProduct();
        setInterval(thirdProduct,15e3)
        tps();
        gamesStore.load();
        getInit(autoApi);
    }, [])
    useEffect(() => {
        if (token) {
            WS.connect(token)
                .subscribe('balance', (v) => {
                    if (v) {
                        if ('string' === typeof v) {
                            v = v.replace(/,/g, '')
                        }
                        if (isNaN(+v)) {
                            return
                        }
                        const m = walletStore.bls['main'];
                        userStore.available = +v;
                        if (m) {
                            m.balance = +v;
                            m.loading = 0;
                        }
                    }
                });
            qW();
            rec();
            queryUS();
            qB();
            walletStore.load().query('main');
            const t = setInterval(() => {
                walletStore.query('main')
            }, 5e3);
            return () => clearTimeout(t)
        }
    }, [token])
    return null;
})

const MyRout = () => {
    useEffect(() => {
        const a = document.getElementById('a');
        if (a) {
            a.className = 'h';
            a.innerHTML = '';
            const o = document.head.querySelector('#h')
            if (o) document.head.removeChild(o);
        }
        const cur = window.location.pathname
        if (!/^\/h5\//.test(cur)) history.replace('/h5' + cur)
    }, [])
    const adapter = (c, i) => {
        const cp = rs[c];
        const cpm = lzK(c);
        const Element = () => {
            const E = props => {
                return <Cpm  {...props} cpm={cpm} c={c}/>
            }
            const match = useMatch(c);
            return <E match={match}/>
        }
        return <Route
            key={'r-' + i}
            path={'/' + c + (cp.exact ? '' : '/*')}
            element={<Element/>}
        />
    };
    const routes = Object.keys(rs).map(adapter);

    const [state, setState] = React.useState({
        action: history.action,
        location: history.location,
    });

    React.useLayoutEffect(() => history.listen((s) => {
        const ss = {...s}
        ss.location = {...s.location, pathname: '/h5' + s.location.pathname.replace(/^\/h5/, '')}
        setState(ss)
    }), [history]);

    return <React.Suspense fallback={<Loading act={1}/>}>
        <Router
            basename={'/h5'}
            location={state.location}
            navigationType={state.action}
            navigator={history}
        >
            <div
                className={'main-view'}
            >
                <div>
                    <Routes>
                        {routes}
                        <Route path={"*"} element={<Navigate to="/"/>}/>
                    </Routes>
                </div>
                <Window/>
                <PopAva/>
                <ServiceWin/>
                <SrvPop/>
            </div>
            <Init/>
        </Router>
    </React.Suspense>
}


export default MyRout;
